import { Component } from 'react';
import CheckData from '../../../../../../components/CatchError';
import DataTable from '../../../../../../components/Datatable';
import ExtraBox from './extrabtns';
import { withTranslation } from 'react-i18next';

class Item extends Component {
    render() {
        const { t } = this.props;
        const extraBtns = () => (
            <ExtraBox
                select={this.props.select}
                handleSelectChange={this.props.handleSelectChange}
            />
        );
        return (
            <div className="card table-main rounded-main overflow-hidden">
                <CheckData data={this.props.data} loading={!this.props.data && this.props.loading}>
                    <DataTable
                        nodes={this.props.data ?? []}
                        sortFns={this.props.sortFns}
                        COLUMNS={this.props.columns ?? []}
                        header={this.props.title}
                        fileName=""
                        additionalBox={extraBtns}
                        defaultSortKey={this.props.defaultSortKey}
                        EXTRA_HEADER={this.props.EXTRA_HEADER ?? []}
                        forceRun={this.props.forceRun}
                        searchFunction={this.props.searchFunction}
                        additionalStyles={this.props.additionalStyles}
                        headerHasCustomStyles={true}
                        customEmptyMessage={t('global.no_data')}
                    />
                </CheckData>
            </div>
        );
    }
}

export default withTranslation()(Item);
